import { ILanguages } from '@picsart/rc/languages';
import { languagesList } from 'constants/languages';
import { AppRoutes } from 'strapi/types';

export const getDropdownLanguagesList = (
  pageSlug: string,
  languageList?: ILanguages,
): ILanguages => {
  switch (pageSlug) {
    case AppRoutes.NOT_FOUND:
    case AppRoutes.BRANDS:
      return {
        en: languagesList.full.en,
      };
    case AppRoutes.APPS:
      return {
        ja: languagesList.full.ja,
      };
    default:
      return pageSlug?.startsWith(AppRoutes.BRANDS)
        ? {
            en: languagesList.full.en,
          }
        : languageList;
  }
};
